/** @file slotMenu: the right-click menu of a slot card, a thin builder over the shell's menu registry. */
import type { MenuItem } from '../../state/editorTypes';
import { buildMenu } from '../../shell/menu/buildMenu';
import type { ArtSlot } from './artTypes';

/** What the menu items do; the screen supplies them for the clicked slot. */
export type SlotMenuOps = {
  upload: () => void; paint: () => void; clear: () => void; mask: (style: 'silhouette' | 'skeleton') => void;
  copyMirrored: () => void; ask: () => void;
};

/** Upload, Paint, Clear, mask downloads, Copy from mirrored slot, Ask the agent (chords read live from the Art key table). */
export function slotMenu(slot: ArtSlot, ops: SlotMenuOps, mirroredFilled: boolean): MenuItem[] {
  return buildMenu('slot', { surface: 'art', slot, ops, mirroredFilled });
}
